export const SET_DESKTOP_MODE = 'SET_DESKTOP_MODE';
export const SET_MENU = 'SET_MENU';
